import React, { useState } from 'react';
import { ConfigurationSection, SpaceBetweenRow } from "@features/settings/pages/StyleComponents";
import { BodyLarge, BodyRegular } from "../../atoms/fonts/Body";
import Colours from "../../atoms/Colours";
import { SimpleSpinner } from "../../atoms/SimpleSpinner";
import { Switch } from "../../atoms/Switch";
import { useDispatch, useSelector } from "react-redux";
import { selectCurrentUser } from '@shared/store/auth.duck';
import { updateSevenDayWorkingWeekSetting } from '@features/auth/store/onboarding.duck';
import { useTranslation } from "react-i18next";

export function SevenDayWorkingWeekSettings(props: Props) {
  const [isLoading, setIsLoading] = useState(false);
  const dispatch = useDispatch();
  const user = useSelector(selectCurrentUser);
  const {t} = useTranslation();

  const onChange = (val: boolean) => {
    setIsLoading(true);
    try {
      dispatch(updateSevenDayWorkingWeekSetting(val));
    } finally {
      setIsLoading(false);
    }
  }

  return (
    <ConfigurationSection>
      <SpaceBetweenRow>
        <BodyLarge colour={Colours.blue}>{t('settings.seven-day.title')}</BodyLarge>
        {isLoading ? <SimpleSpinner size={32} /> : <Switch value={!!user?.companyEntity.sevenDayWhereaboutsWeekEnabled} label="" onChange={onChange}/>}
      </SpaceBetweenRow>
      {user?.companyEntity.sevenDayWhereaboutsWeekEnabled ? <>
        <BodyRegular style={{marginBottom: 8}}>{t('settings.seven-day.enabled-message')}</BodyRegular>
      </> : <>
        <BodyRegular style={{marginBottom: 8}}>{t('settings.seven-day.disabled-message')}</BodyRegular>
      </>}
    </ConfigurationSection>
  )
}

interface Props {
}
